import { render, staticRenderFns } from "./coponent2.vue?vue&type=template&id=5d240e78&scoped=true&"
import script from "./coponent2.vue?vue&type=script&lang=js&"
export * from "./coponent2.vue?vue&type=script&lang=js&"
import style0 from "./coponent2.vue?vue&type=style&index=0&id=5d240e78&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./coponent2.vue?vue&type=style&index=1&id=5d240e78&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style2 from "./coponent2.vue?vue&type=style&index=2&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d240e78",
  null
  
)

export default component.exports